import { render, staticRenderFns } from "./bwtemplates.vue?vue&type=template&id=abf2ca88&"
import script from "./bwtemplates.vue?vue&type=script&lang=js&"
export * from "./bwtemplates.vue?vue&type=script&lang=js&"
import style0 from "./bwtemplates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports